module.exports = __webpack_public_path__ + "static/media/04_1.7752c441.png";